/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Button } from '@msdyn365-commerce-modules/utilities';
import { RichTextComponent, RichText } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import { isShareholderAccountNotInactive, isShareholderAccountNotOnHold } from '../../../common/method/functions';
export interface IAddPaymentFormProps {
    canSubmit?: boolean;
    canCancel?: boolean;
    hasSelectedItem?: boolean;
    resources: {
        cancelButtonText: string;
        submitButtonText: string;
        iframeAriaLabel: string;
    };
    image?: React.ReactNode;
    inputLabel: string;
    text: React.ReactNode;
    onHoldMessage: RichText;
    suspendedMessage: RichText;
    title: string;
    cart: any;
    accountName?: string;
    onSubmit?(): void;
    onCancel?(): void;
}

/**
 *
 * AddPaymentForm SFC
 * @extends {React.SFC<IAddPaymentFormProps>}
 */
const AddPaymentForm: React.SFC<IAddPaymentFormProps> = ({
    onSubmit,
    onCancel,
    canSubmit,
    canCancel,
    resources: { cancelButtonText, submitButtonText },
    title,
    inputLabel,
    image,
    cart,
    text,
    onHoldMessage,
    suspendedMessage,
    accountName
}) => {
    const isAccountNotInactive = isShareholderAccountNotInactive(cart.ExtensionProperties);
    const isAccountNotOnHold = isShareholderAccountNotOnHold(cart.ExtensionProperties);

    return (
        <div className={classnames('ms-checkout-shareholder-payment')}>
            <div className='fl-shareholder-title-container'>
                {image}
                <h4 className='fl-shareholder-title'>{title}</h4>
            </div>
            <div className='fl-shareholder-contents'>
                <RichTextComponent text={`<div class="content">${text}</div>`} className='ms-content-block__text' />
                <label className='ms-checkout__input-label'>
                    {inputLabel}
                    <input type='text' name='farmland-account-number' value={`${cart.CustomerId} - ${accountName}`} disabled />
                </label>
            </div>
            <div className='fl-shareholder-footer'>
                {!isAccountNotOnHold && <RichTextComponent text={onHoldMessage} />}
                {!isAccountNotInactive && <RichTextComponent text={suspendedMessage} />}
            </div>
            {canSubmit && (
                <Button className='ms-checkout-payment-instrument__btn-save' title={submitButtonText} color='primary' onClick={onSubmit}>
                    {submitButtonText}
                </Button>
            )}
            {canCancel && (
                <Button
                    className='ms-checkout-payment-instrument__btn-cancel'
                    title={cancelButtonText}
                    color='secondary'
                    onClick={onCancel}
                >
                    {cancelButtonText}
                </Button>
            )}
        </div>
    );
};

export default React.memo(AddPaymentForm);
